import { useMemo, useEffect, useState, SyntheticEvent } from "react";
import { Autocomplete, Chip, TextField, Typography } from "@mui/material";
import { EsercizioCorrelatoObject, Esercizio } from "../interfaces/Esercizio";
import { Stack } from "react-bootstrap";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


type EsercizioCorrelatoProps = {
    current_id: number;
    esercizioCorrelato: number | null;
    onChange: (value: number | null) => void;
};

const EsercizioCorrelato: React.FC<EsercizioCorrelatoProps> = ({ current_id, esercizioCorrelato = null, onChange }) => {
    const [eserciziCorrelabili, setEserciziCorrelabili] = useState<EsercizioCorrelatoObject[]>([]);
    const esercizioCorrelatoNessuno: EsercizioCorrelatoObject = {
        id: 0,
        position: "",
        full_name: "Nessuno",
    }

    const fetchEserciziCorrelabili = async (current_id: number) => {
        try {
            const headers = new Headers();
            headers.set('Accept', 'application/json');
            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            }
            const response = await fetch('/api/v0/activities-pairable/' + current_id, requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');
            const data: EsercizioCorrelatoObject[] = await response.json();
            data.unshift(esercizioCorrelatoNessuno); 
            setEserciziCorrelabili(data);
        } catch (err: any) {
            console.log(err.message);
        }
    };

    useEffect(() => {
        fetchEserciziCorrelabili(current_id!=null ? current_id : 0)
    }, [current_id]);

//    useEffect(() => {
//        if(eserciziCorrelabili.length>0){
//
//        }
//    }, [esercizioCorrelato]);

    const handleEsercizioCorrelatoChange = (
        event: SyntheticEvent,
        newValue: EsercizioCorrelatoObject | null
    ) => {
        if(newValue){
            onChange(newValue.id != 0 ? newValue.id : null);
        }
    };

    const selectedEsercizioCorrelato = useMemo(
      () => eserciziCorrelabili.find(e => e.id === esercizioCorrelato) ?? esercizioCorrelatoNessuno,
      [eserciziCorrelabili, esercizioCorrelato]
    );
    //console.log(selectedEsercizioCorrelato)

    return (
        <>
        <div className="mb-4">
            {/*<div className="row mb-2">
                <h5 className="font-semibold mb-1">Esercizio Correlato</h5>
            </div>*/}
            <Autocomplete
                disableClearable
                options={eserciziCorrelabili}
                getOptionLabel={(option) => option.position + " - " + option.full_name}
                value={selectedEsercizioCorrelato}
                onChange={handleEsercizioCorrelatoChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Esercizio correlato"
                        placeholder="Esercizio correlato"
                        InputProps={{
                            ...params.InputProps,
                            style: {
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            },
                        }}
                    />
                )}
            />
        </div>
        </>
    );
};

export default EsercizioCorrelato
